import React, { useEffect, useMemo, useState } from "react";
import Navbar from "../../Navbar";
import { getData } from "../../../services/library";
import { logEventos } from "../../../services/services";
import { Autorenew } from "@mui/icons-material";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import {
  Button,
  Container,
  ListItemIcon,
  MenuItem,
  Typography,
} from "@mui/material";
import MaterialReactTable from "material-react-table";
import ActualizarPrecios from "./ActualizacionPrecio/ActualizarPrecios";
import DialogPrecioParticular from "./precioParticular/DialogPrecioParticular";
import HistoryIcon from "@mui/icons-material/History";
import HistorialRangoPrecios from "./historial/HistorialRangoPrecios";

function TablaRangoPrecios() {
  const [lista, setLista] = useState([]);
  const [tabla, setTabla] = useState(true);
  const [rowData, setrowData] = useState();
  const [actualizarGeneral, setActualizarGeneral] = useState(false);
  const [actualizarParticular, setActualizarParticular] = useState(false);
  const [verHistorial, setVerHistorial] = useState(false);
  const obtenerPrecios = () => {
    const sucursales = localStorage.getItem("suc_auth"); // Esto ya es un string como "1,2,3"
  getData(`/envasado_rango_precios/sucauth/${sucursales}`, setLista);
  };

  useEffect(() => {
    obtenerPrecios();
  }, []);

  const handleAbrirActualizar = () => {
    setActualizarGeneral(true);
  };

  const handleAbrirPrecioParticular = (row) => {
    setActualizarParticular(true);
    setrowData(row);
  };

  const handleVerHistorial = () => {
    setTabla(false);
    setVerHistorial(true);
  };

  const handleCloseHistorial = () => {
    setVerHistorial(false);
    setTabla(true);
  };

  const columns = useMemo(
    () => [
      { header: "Sucursal", accessorKey: "nombre_sucursal", size: 100 },
      { header: "Producto", accessorKey: "nombre_producto", size: 100 },
      { header: "Precio Mínimo", accessorKey: "precio_minimo", size: 100 },
      { header: "Precio Máximo", accessorKey: "precio_maximo", size: 100 },
    ],
    [],
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  const customLocalization = {
    ...MRT_Localization_ES,
    expandAll: "Ex", // Cambia 'Expandir todo' a 'Ex'
    expand: "Ex", // Cambia 'Expandir' a 'Ex'
  };

  const initialState = {
    density: "compact",
    pagination: { pageIndex: 0, pageSize: 10 },
    grouping: ["nombre_sucursal"],
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  useEffect(() => {
    logEventos(
      "tabla de precios minimos y maximos",
      "Envasado",
      "precios minimos y maximos envasado",
      localStorage.getItem("user"),
    );
  }, []);

  return (
    <>
      {tabla && (
        <>
          <Navbar />
          <Container maxWidth="xl" sx={{ my: 1 }} disableGutters>
            <MaterialReactTable
              columns={columns}
              data={lista ?? [{}]}
              layoutMode={"grid"}
              initialState={initialState}
              enableColumnActions={false}
              enableGlobalFilterModes={false}
              enableHiding={false}
              enableRowActions={true}
              enableGrouping={true}
              enablePinning={true}
              enableColumnFilters={false}
              enableFullScreenToggle={false}
              positionActionsColumn={"last"}
              enableExpandAll={false}
              localization={customLocalization}
              enableToolbarInternalActions={true}
              muiTableHeadCellProps={tableHeadCellProps}
              muiSearchTextFieldProps={muiSearchTextFieldProps}
              enableDensityToggle={false}
              positionToolbarAlertBanner="none"
              muiTableDetailPanelProps={{
                sx: {
                  backgroundColor: "white", // Fondo blanco para el panel de detalles
                  width: "100%",
                },
              }}
              enableColumnResizing={true}
              muiTableBodyCellProps={({ row }) => ({
                align: "left",
              })}
              renderTopToolbarCustomActions={() => (
                <>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<Autorenew />}
                    onClick={handleAbrirActualizar}
                  >
                    Actualizar Precios
                  </Button>
                  <Typography variant="poster" fontSize={26}>
                    Precios Mínimos y Máximos
                  </Typography>
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<HistoryIcon />}
                    onClick={handleVerHistorial}
                  >
                    Historial
                  </Button>
                </>
              )}
              renderRowActionMenuItems={({ closeMenu, row, index }) => [
                <MenuItem
                  key={0}
                  sx={{ m: 0 }}
                  onClick={() => {
                    handleAbrirPrecioParticular(row.original);
                    closeMenu();
                  }}
                >
                  <ListItemIcon>
                    <Autorenew color="primary" />
                  </ListItemIcon>
                  Actualizar precio
                </MenuItem>,
              ]}
            />
          </Container>
        </>
      )}
      {actualizarGeneral && (
        <ActualizarPrecios
          open={actualizarGeneral}
          setOpen={setActualizarGeneral}
          onClose={() => {
            setActualizarGeneral(false);
            obtenerPrecios();
          }}
          lista={lista}
        />
      )}
      {actualizarParticular && (
        <DialogPrecioParticular
          open={actualizarParticular}
          setOpen={setActualizarParticular}
          onClose={() => {
            setActualizarParticular(false);
            obtenerPrecios();
          }}
          row={rowData}
        />
      )}
      {verHistorial && <HistorialRangoPrecios onClose={handleCloseHistorial} />}
    </>
  );
}

export default TablaRangoPrecios;
